import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/unbounded/600.css";
import "@fontsource/unbounded/700.css";
import "@fontsource/golos-text/400.css";
import "@fontsource/golos-text/500.css";
import "@fontsource/golos-text/600.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/ecg.css";
import "./styles/ui.css";
import "./styles/shell.css";
import "./styles/login.css";
import "./styles/feed.css";
import "./styles/vk.css";
import "./styles/editor.css";
import "./styles/write.css";
import "./styles/auto.css";
import "./styles/calendar.css";
import "./styles/postponed.css";
import "./styles/projects.css";
import "./styles/settings.css";
import { App } from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
